import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onClose: () => void;
  transparent?: boolean;
  className?: string;
};

export const CloseButton = ({ onClose, transparent, className }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <IconButton
      size="medium"
      onClick={onClose}
      icon={faTimes}
      color={transparent ? 'transparent' : 'tertiary'}
      aria-label={formatMessage(glossary.close)}
      className={className}
    />
  );
};
